// src/config.js
export const API_BASE_URL = import.meta.env.DEV
  ? "http://localhost:5000"
  : "https://sababa-tours-backend.onrender.com";
